/** One heading in a document outline. */
export interface OutlineItem {
  level: number; // 1..6
  text: string;
  line: number; // 1-based source line
}

const HEADING = /^(#{1,6})\s+(.+?)\s*#*\s*$/;
const FENCE = /^\s*(```|~~~)/;

/** Strip the most common inline markdown so outline labels read cleanly. */
function cleanLabel(s: string): string {
  return s
    .replace(/`([^`]+)`/g, '$1')
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/\*([^*]+)\*/g, '$1')
    .replace(/__([^_]+)__/g, '$1')
    .replace(/_([^_]+)_/g, '$1')
    .replace(/~~([^~]+)~~/g, '$1')
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
    .trim();
}

/**
 * Parse ATX headings (`#`..`######`) into a flat outline, skipping headings
 * inside fenced code blocks. Line numbers are 1-based to match the editor.
 */
export function parseOutline(content: string): OutlineItem[] {
  const out: OutlineItem[] = [];
  let inFence = false;
  let fenceMarker = '';
  const lines = content.split('\n');
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i]!;
    const fence = line.match(FENCE);
    if (fence) {
      const marker = fence[1]!;
      if (!inFence) {
        inFence = true;
        fenceMarker = marker;
      } else if (marker === fenceMarker) {
        inFence = false;
        fenceMarker = '';
      }
      continue;
    }
    if (inFence) continue;
    const m = line.match(HEADING);
    if (m) {
      out.push({ level: m[1]!.length, text: cleanLabel(m[2]!), line: i + 1 });
    }
  }
  return out;
}
